import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { animalKeys } from '../queries/keys';
import { animalPaths } from '../queries/paths';

// TSS vite/03 — Ubicación de la vaca (admin-animals.md · 0036). Traslado de finca PURO,
// desacoplado del billing (no toca manejos/estadías): setea animals.current_farm_id y registra
// una fila en la bitácora animal_farm_moves. GET historial + finca actual (animals:read);
// POST traslado (animals:write).

// GET /admin/animals/:id/farm-moves → { animal_id, current_farm, items:[{from_farm,to_farm,moved_on,moved_by}] }.
export function useFarmMoves(animalId) {
    return useQuery({
        queryKey: animalKeys.farmMoves(animalId),
        queryFn:  ({ signal }) => api.get(animalPaths.farmMoves(animalId), { signal }).then(r => r.data),
        enabled:  !!animalId,
    });
}

// POST /admin/animals/:id/transfer-farm — body { to_farm_id, date, remarks? }.
export function useTransferFarm(animalId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.post(animalPaths.transferFarm(animalId), payload).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: animalKeys.farmMoves(animalId) }),
    });
}
